/*
**	Functions for using Google Ads dynamically
**  by Nate Beversluis, 2020
*/

function waitForGoogleTag() {
   
    /*
    ** Refreshes Google Ads. If GoogleTag is not already in the environment, wait until it is present
    ** and then refresh the ads.
    */

    if (window.googletag && window.googletag.apiReady) { 		
        window.googletag.pubads().addEventListener('slotRenderEnded', function(event) {
            var slot = event.slot;
            var elID = slot.getSlotElementId();
            if ( elID == 'ad_pos_wfmt_homepage_leaderboard_upper_728x90') {return }
            if ( elID == 'ad_pos_wfmt_homepage_leaderboard_upper_300x100') {return }
            if (event.isEmpty) {
                googletag.pubads().refresh([slot]);
            }
        });
    } else {
        setTimeout( function() {
            waitForGoogleTag();
        }, 500);
    }
}

function forceAd(slot) {
    
    /*
    ** For ad slots (other than the two excluded below) to 
    ** always show an ad, even if the first try does not deliver one.
    ** This works around the fact that DFP does not expect to search
    ** more than one ad per page, and on this site the page no longer refreshes after initial
    ** ad delivery.
    */

    var elID = slot.getSlotElementId();
    if ( elID == 'ad_pos_wfmt_homepage_leaderboard_upper_728x90') {return }
    if ( elID == 'ad_pos_wfmt_homepage_leaderboard_upper_300x100') {return }

    jQuery('#'+elID).each( function() { 

        var style = jQuery(this).attr('style');

        if ( ( style && style.includes('display: none') ) 
            || jQuery(this).has('iframe').length == 0 
            ) {	
                googletag.pubads().refresh([slot]);
            }
    });
}

export { waitForGoogleTag, forceAd }